import { solarProductAxios } from '@infrastructure/apiService'

const factory = (service) => ({
  async getMonthlySummary() {
    const { data } = await service.get(
      '/private/agent/me/gross-margin-summary',
      { timeout: 10000 }
    )
    return data
  },
})

export default factory(solarProductAxios)
